import React, { useState, useEffect } from 'react';
import { Tooltip, Card, Radio, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext, useStaffContext, useDataContext } from 'store';
import Icon from 'component/icon';

const Setting = ({ cityName }) => {
    const {
        setStations, setStationGroup, setStationOwners, setCarModels,
        setCarMileages, setCarInsurances, setExtraFees, setCars,
        setTechnicianGroups, setTechnicians, setStaffs, setCompanies,
        setRegions, setRatingItems
    } = useDataContext();
    const { menuPosition, setMenuPosition, isMobileView } = useGlobalContext();
    const { logout } = useStaffContext();

    const [isFullscreen, setIsFullscreen] = useState(false);
    useEffect(() => {
        const handleFullscreenchange = () => setIsFullscreen(!!document.fullscreenElement);
        document.addEventListener('fullscreenchange', handleFullscreenchange);
        return () => window.removeEventListener('fullscreenchange', handleFullscreenchange);
    }, []);
    const handleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.body.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    };

    const [toolTipOpen, setTooltipOpen] = useState(false);
    const onChangeMenuPosition = (value) => {
        setMenuPosition(value);
        setTooltipOpen(false);
    };

    const navigate = useNavigate();
    const logoutHandler = () => {
        setStaffs([]);
        setCompanies([]);
        setRegions([]);
        setRatingItems([]);
        setStations([]);
        setStationGroup([]);
        setStationOwners([]);
        setCarModels([]);
        setCarMileages([]);
        setCarInsurances([]);
        setExtraFees([]);
        setCars([]);
        setTechnicianGroups([]);
        setTechnicians([]);
        navigate('/login');
        logout();
    };

    return (
        <div className="flex items-center gap-4 text-primary">
            {!isMobileView && (
                <Icon
                    name={isFullscreen ? 'fullscreen_exit' : 'fullscreen'}
                    size={24}
                    className="cursor-pointer"
                    onClick={handleFullscreen}
                />
            )}
            <Tooltip
                destroyTooltipOnHide={{ keepParent: false }}
                open={toolTipOpen}
                onOpenChange={setTooltipOpen}
                trigger="click"
                placement="bottomRight"
                overlayClassName="usermenu"
                title={(
                    <Card className="w-[250px]">
                        <div className="flex items-center w-full mb-4">
                            <div className="w-1/3">選單位置</div>
                            <Radio.Group
                                className="w-2/3"
                                value={menuPosition}
                                onChange={(e) => onChangeMenuPosition(e.target.value)}
                            >
                                <Radio value="left">置左</Radio>
                                <Radio value="top">置頂</Radio>
                            </Radio.Group>
                        </div>
                        <Button type="primary" className="w-full" onClick={logoutHandler}>
                            登出
                        </Button>
                    </Card>
                )}
            >
                <div className="cursor-pointer flex items-center">
                    <Icon name="person" size={24} />
                    <span className="mx-3 font-bold text-base">{cityName}</span>
                    <Icon name="expand_more" size={24} />
                </div>
            </Tooltip>
        </div>
    );
};

export default Setting;
